import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { PDFExport } from "@progress/kendo-react-pdf";

import RMSquat from '../../scchartcomponent/rmsquatchart';
import RMClean from '../../scchartcomponent/rmcleanchart';
import RMBench from '../../scchartcomponent/rmbenchchart';
import KMRun from'../../scchartcomponent/kmrunchart';
import VerticalJump from '../../scchartcomponent/verticaljumchart';
import PullUp from '../../scchartcomponent/pullupchart';
import Acceleration from '../../scchartcomponent/accelerationchart';
import Endurance from '../../scchartcomponent/endurancechart';
import Testbar from '../../scchartcomponent/testbar';
import PageTemplate from "Routes/pdfTemplate";

import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {  
    scVisualisationDetails,
    creatSCVisualisation
} from 'Actions';

class mainvisual extends React.Component {
    static propTypes = {
        classes: PropTypes.object,
    };
    pdfExportComponent;

    constructor(props) {
      
        super(props);
        this.state = {   
            student:this.props.data.student,
            selyear:this.props.data.selyear,
            selassessment:this.props.data.selassessment,
            visualid:this.props.data.visualid, 
            previousLength:0,
            valuelength:0,
        };
       this.selectorRef = React.createRef(null);
    }

    exportPDFWithMethod = () => {
       
        this.selectorRef.current.save();
        // savePDF(this._element, {
        //     paperSize: "A4",
        //     margin: "1cm",
        //     scale: 0.6
        // });
    }

    addHandleSubmit(event){
        event.preventDefault();
         let commayear = ""; 
         let commaassement = ""; 
        let {student, selyear, selassessment, visualid} = this.state;
        if(visualid==""){
            let totsel=selyear.length;
            let asstot=selassessment.length;
            event.preventDefault();
            commayear = selyear.map(item => item).join(', ');  
            if(asstot!=0){
                commaassement = selassessment.map(item => item).join(', ');  
            }
        }else{
            commayear="";
            commaassement="";
        }
        this.props.creatSCVisualisation(event, student, commayear, commaassement, visualid);
        
    }

    handleInput(event) {
        const bullet = "\u2022";
        const inputValue = event.target.value;
        const cursorPosition = event.target.selectionStart;
        let lines = inputValue.split('\n');
      
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          if (!line.trim().startsWith(bullet)) {
            lines[i] = `${bullet} ${line.trimLeft()}`;
          }
        }
      
        let newValue = lines.join('\n');
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          if (cursorPosition === 0) {
            const lineIndex = newValue.substr(0, cursorPosition).split('\n').length - 1;
            if (lineIndex > 0) {
              const linesArray = newValue.split('\n');
              linesArray.splice(lineIndex, 1);
              newValue = linesArray.join('\n');
            }
          } else if (newValue[cursorPosition - 1] === bullet && (cursorPosition === newValue.length || newValue[cursorPosition] === '\n')) {
            newValue = newValue.slice(0, cursorPosition - 2) + newValue.slice(cursorPosition);
          }
        }
      
        event.target.value = newValue;
      
        this.setState({
          previousLength: newValue.length,
        });
     }

    autoResizeTextarea = (element) => {
        
        element.style.height = 'auto'; 
        element.style.height = `${element.scrollHeight}px`;
    }

  render() {

    const { scvisualisationdetails, loading} = this.props;
    let visualdetails=scvisualisationdetails[0].visualimpression;
    let summary_notes='';
    let clubhd_impression='';
    let clubhdshrtgoal1='';
    let clubhdlonggoal1='';
    let clubhd_approach='';
    if(visualdetails.length!=0){
        summary_notes= visualdetails[0].summary_notes; 
        clubhd_impression=visualdetails[0].clubhd_impression; 
        clubhdshrtgoal1=visualdetails[0].clubhdshrtgoal1; 
        clubhdlonggoal1=visualdetails[0].clubhdlonggoal1; 
        clubhd_approach=visualdetails[0].clubhd_approach; 
        
    }
    const styles = {
        mainheading: {
            fontWeight:"bold",
            marginBottom:"30px",
            color:"#000",
            marginTop:"80px"
        },
        subheading: {
            fontWeight:"bold",
            marginTop:"120px", 
            marginBottom:"30px",
            color:"#000"
        },
        subheadingsecond: {
            fontWeight:"bold",
            marginTop:"80px", 
            marginBottom:"30px",
            color:"#000"
        },
        subheadingfirst: {
            fontWeight:"bold",
            marginTop:"80px", 
            marginBottom:"30px",
            color:"#000"
        },
        goals:{
            marginTop:"30px",
            marginBottom:"20px",
            color:"#000"
        },
        goalhead:{
          fontWeight:"bold",
          color:"#000"
        },        
        eachchart:{
           padding:"10px",
           marginBottom:"50px",
        },
        texare:{
            color:"#000",
        },
        table: {
            border: "1px solid black",
            borderColor:"black",
            borderStyle:"solid",
            fontFamily: "Arial", 
            width: "100%",
        },
        tableContainer: {
            display: "flex",
            overflow: "auto",
            width: "100%",
            height: "100%",
          },
        tabletrtd: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word",            
            textAlign: "center",
            color:"#000"
        },
        tabletleft: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word"
            
        },
        tabletrtdhead: {
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: "black",
            borderCollapase: "collapse",
            borderSpacing: "0px",
            whiteSpace: "pre-line",
            wordWrap: "break-word",            
            textAlign: "center",
            color:"#000",
            fontWeight:"bold"
        },
        rctcontent:{            
            marginTop:"80px",
            borderRadius: "5px",
            boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
            border: "none",            
            transition: "all 0.4s ease-in-out 0s",
            marginBottom: "50px",
            
        }
    };   
 
   
    return (

        <RctCollapsibleCard fullBlock >
            <div className="bjjt">
            <input type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} value="Back" />
            </div>
            <form autoComplete="off" id="visualisationform" onSubmit={(e)=>this.addHandleSubmit(e)}>  
                
                 <PDFExport   
                        pageTemplate={PageTemplate}                    
                        scale={0.6}
                        paperSize="A4"
                        margin="1cm"                     
                        fileName="S&C Visualisation"
                        ref={this.selectorRef}
                        forcePageBreak=".page-break" 
                        >          
                <div style={styles.rctcontent}>
                    
                    <div className="rwhead" style={{marginTop:"100px"}}>
                        <h3 className="text-center" style={styles.mainheading}>COMPARATIVE ANALYSIS OF STRENGTH & CONDITIONING</h3>
                    </div>
                    {scvisualisationdetails[0].onermsquat.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheadingfirst}>1RM Back Squat</h3>
                    <div className="charttcomponent"  style={styles.eachchart}>
                        <RMSquat data={"95%"} />
                    </div>
                    </>
                    :''}
                    
                    {scvisualisationdetails[0].onermclean.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheading}>1RM Clean</h3>
                     <div style={styles.eachchart}>
                        <RMClean data={"95%"}/>
                    </div>                    
                    </>
                    :''}

                     {/* {scvisualisationdetails[0].onermsquat.length!=0&&scvisualisationdetails[0].onermclean.length!=0 ?
                       <div className="page-break"></div> : ''
                     }    */}


                    {scvisualisationdetails[0].onermbench.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheading}>1RM Bench Press</h3>
                     <div style={styles.eachchart}>
                        <RMBench data={"95%"}/>
                    </div>
                    </>
                    :''}

                    {/* {scvisualisationdetails[0].onermsquat.length!=0&&scvisualisationdetails[0].onermclean.length==0&&scvisualisationdetails[0].onermbench.length!=0 ?
                       <div className="page-break"></div> : ''
                    } */}

                    {scvisualisationdetails[0].kmrun.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheading}>Aerobic Fitness Test (2.4km Run)</h3>
                     <div style={styles.eachchart}>
                        <KMRun data={"95%"}/>
                    </div>
                    
                    </>
                    :''}
                    
                    {scvisualisationdetails[0].verticaljump.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheading}>Lower Body Power Test (Vertical Jump)</h3>
                     <div style={styles.eachchart}>
                        <VerticalJump data={"95%"}/>
                    </div>
                    </>
                    :''}
                    
                    {scvisualisationdetails[0].pullup.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheading}>Upper Body Strength Test (Pull Up)</h3>
                     <div style={styles.eachchart}>
                        <PullUp data={"95%"}/>
                    </div>
                    
                    </>
                    :''}
                    
                    {scvisualisationdetails[0].acceleration.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheading}>Acceleration Speed Test (20m Sprint Speed)</h3>
                    <div style={styles.eachchart}>
                        <Acceleration data={"95%"}/>
                    </div>
                    </>
                    :''}
                    
                    {scvisualisationdetails[0].endurance.length!=0 ?
                    <>
                    <h3 className="text-center" style={styles.subheading}>Core Endurance Test (Plank)</h3>
                    <div style={styles.eachchart}>
                        <Endurance data={"95%"}/>
                    </div>
                     
                    </>
                    :''}
                    <div className="page-break"></div>    
                    <h3 className="text-center" style={styles.subheading}>SUMMARY NOTES </h3>
                    <div style={styles.eachchart}>
                        <div className="rwhead">
                            <textarea rows="4" type="text" style={styles.texare} name="summary_notes" id="summary_notes" defaultValue={summary_notes} className="form-control form-control-alternative" onChange={evt => { this.handleInput(evt); this.autoResizeTextarea(evt.target); }}></textarea>
                        </div>
                    </div>

                    <h3 className="text-center" style={styles.subheading}>PERFORMANCE ENHANCEMENT</h3>
                    <div style={styles.eachchart}>
                    <div style={styles.tableContainer}>
                            <table className="table align-items-center table-flush" style={styles.table}>
                                    <tbody>
                                        <tr>                                          
                                            <td rowSpan="2" style={styles.tabletrtdhead}>IMPRESSION  </td>
                                            <td colSpan="2" style={styles.tabletrtdhead}>GOAL  </td>
                                            <td rowSpan="2"style={styles.tabletrtdhead}>APPROACH </td>
                                        </tr>
                                        <tr>
                                            <td style={styles.tabletrtdhead}>Short Term Goals</td>
                                            <td style={styles.tabletrtdhead}>Long Term Goals</td>
                                        </tr> 
                                        <tr>  
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhd_impression} name="clubhd_impression" id="clubhd_impression" onChange={evt => { this.handleInput(evt); this.autoResizeTextarea(evt.target); }}></textarea></td>
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhdshrtgoal1} name="clubhdshrtgoal1" id="clubhdshrtgoal1" onChange={evt => { this.handleInput(evt); this.autoResizeTextarea(evt.target); }}></textarea></td>
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhdlonggoal1} name="clubhdlonggoal1" id="clubhdlonggoal1"  onChange={evt => { this.handleInput(evt); this.autoResizeTextarea(evt.target); }}></textarea></td>
                                            <td style={styles.tabletleft}><textarea style={{border:"0px", backgroundColor: "unset"}} rows="10" type="text" defaultValue={clubhd_approach} name="clubhd_approach" id="clubhd_approach" onChange={evt => { this.handleInput(evt); this.autoResizeTextarea(evt.target); }}></textarea></td>                                                   
                                        </tr>                           
                                    </tbody>
                                </table>   
                                </div>
                    </div>
                   
                </div>  
                </PDFExport>
                <div className="rwhead">
                    <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                    <button type="button" className="mr-3 mb-3 btn btn-outline-success" onClick={this.exportPDFWithMethod}>Export PDF</button>
                    <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} value="Back" />
                </div>
            </form>
        </RctCollapsibleCard> 
      
    );
  }
}

const mapStateToProps = ({ scvisualisation }) => {
  const { scvisualisationdetails, loading } = scvisualisation;
return { scvisualisationdetails, loading };
}

export default connect(mapStateToProps, {
    scVisualisationDetails,
    creatSCVisualisation
})(mainvisual); 